import { r as registerInstance, h, H as Host } from './index-44bf8136.js';
import { b as getIonMode } from './ionic-global-837be8f3.js';
import { c as createColorClasses } from './theme-3f0b0c04.js';

const textCss = ":host(.ion-color){color:var(--ion-color-base)}";

const Text = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
    }
    render() {
        const mode = getIonMode(this);
        return (h(Host, { class: Object.assign(Object.assign({}, createColorClasses(this.color)), { [mode]: true }) }, h("slot", null)));
    }
};
Text.style = textCss;

export { Text as ion_text };
